<template>
    <div class="page" id="page_ourForte">
        <header class="hgroup">
            <h2>Our Forte</h2>
            <p>The Experience &amp; Expertise to Put You Ahead of the Game.</p>
        </header>
        <div class="content-container"> 
        <ol class="">
            <li id="ourFortePromises">
                <h4>Forte's Promise</h4>
                <p>Forte was specially created to deliver Exceptional Events and Extraordinary Experiences to our clients who require creativity and an excellent standard of customer service in regards to group travelling management. As our name suggests, Forte’s strength lies in creating unique and unforgettable travel experiences for you and your delegates. Be it a local or an overseas trip for incentive, meetings, teambuilding, conventions or exhibitions, Forte has the expertise and extensive partnerships to deliver our promise.</p>
            </li>
            <li id="ourForteSurprises">
                <h4>Endless Surprises</h4>
                <p>Be it a gala dinner beside the mysterious Egyptian Pyramids, an appreciation night with the Great Wall of China and spectacular fireworks as the backdrop, a magical teambuilding at Disneyland or an adrenaline rush encounter with the Big Five at South Africa, we have done it, we have seen it, and it is time to picture your company at one of the wonders of the world.</p>
            </li>
            <li id="ourForteCommitment">
                <h4>Our Commitment</h4>
                <p>From the start of planning the event to the day of execution, Forte’s team of highly credible industry veterans and young result-oriented professionals will dedicate themselves to ensure the success of your event. You can be assured that Forte’s core competencies and strong affiliations with the regional leading travel industry companies will deliver unparalleled experiences, competitive proposals and memorable trips for you and your delegates.</p>
            </li>
            <li id="ourForteBeyond">
                <h4>Beyond Forte</h4>
                <p>Forte is a brand of Corporate Travel Services Pte Ltd, CTS, which has been established since 1988 and has evolved to be one of the top Travel Management Companies in Singapore. Its extensive clientele of more than 4,500 companies stretches across all kinds of industries including the oil and gas, medical, property estates, engineering, construction and many more. CTS comprises of more than 160 dedicated professionals and yields an annual turnover of more than SGD 150 million. In addition to Forte are the affiliations of CTS entrepreneurs: Travel Management Online, Corporate Travel Alliance, East Asia Travel and Sakura Holidays.</p>
            </li>
        </ol>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OurForte'
}
</script>

<style lang="less" scoped>
#page_ourForte {
    //background: #faf6f4 url(../../public/images/bg2.jpg) repeat left top;
    background: @lightColor;

    h4 {
        padding: 100px 0 0;
        position: relative;
        text-align: center;
    }
    p {
        margin: 0;
        text-align: justify;
    }
    ol {
        list-style: none;

        li {
            margin: 60px 0;
        }
    }
}
h4:before  {
    content: "1";
    font-size: 3.167em;
    color: @grey;
    line-height: 0;
    margin-right: 10px;
}

#ourFortePromises h4 {
    background: url(../../public/images/our-forte-promises.png) no-repeat center 0px;

    &:before {
        content: '1';
    }
}
#ourForteSurprises h4 {
    background: url(../../public/images/our-forte-surprises.png) no-repeat center 0px;

    &:before {
        content: '2';
    }
}
#ourForteCommitment h4 {
    background: url(../../public/images/our-forte-commitment.png) no-repeat center 0px;
    &:before {
        content: '3';
    }
}
#ourForteBeyond h4 {
    background: url(../../public/images/our-forte-beyond.png) no-repeat center 0px;
    &:before {
        content: '4';
    }
}

@media only screen and (min-width : 768px) {
#page_ourForte {
    h2,p {
        text-align: center;
    }

    ol {
        display: flex;
        flex-wrap: wrap;

        li {
            margin: 0 2.5%;
            width: 45%;
        }
    }
}

}

</style>